"use client";
import { rpc } from "#rpc";
import { useToken } from "@frend-digital/centra/client";
import { useQuery } from "@tanstack/react-query";
import { Suspense } from "react";
import ProductCard from "../ProductCard";
import styles from "./index.module.css";

import type { ProductCard as ProductCardType } from "@/lib/centra/formatters";
export const RecentlyViewedProducts = ({ uri }: { uri: string }) => {
  const token = useToken();
  const { data: products } = useQuery({
    queryKey: ["recently-viewed", uri],
    queryFn: async () => {
      const products = await rpc.depict.recommendations({
        product_ids: [],
        type: "recently_viewed",
        limit: 4,
        token: token!,
      });

      return products;
    },
    enabled: !!token,
  });

  if (!products || products.length === 0) return null;

  return (
    <div className={styles.relatedProducts}>
      <Suspense fallback>
        <UnsuspendedRecentlyViewedProducts products={products} />
      </Suspense>
    </div>
  );
};

const UnsuspendedRecentlyViewedProducts = ({
  products,
}: {
  products: (ProductCardType | undefined)[];
}) => {
  return (
    <>
      <div data-layout="page" className={styles.title}>
        <h2>Recently viewed</h2>
      </div>
      <div data-layout="page" className={styles.relatedProductsGrid}>
        {products?.map((product) => {
          return (
            <ProductCard
              related
              key={product?.displayItemId}
              product={product!}
            />
          );
        })}
      </div>
    </>
  );
};
export default RecentlyViewedProducts;
